/* ============================================================
   CARRITO DESLIZABLE + ENVÍO GRATIS + RECOMENDADOS
   ------------------------------------------------------------
   Archivo cacheable entre páginas. La configuración del
   Customizer llega en el bloque JSON #cudConfig que imprime
   sections/cart-upsell-drawer.liquid.
   ============================================================ */
(function () {
  'use strict';

  if (window.__cudInit) return;
  window.__cudInit = true;

  /* ====== CONFIGURACIÓN (leída del bloque JSON del Customizer) ====== */
  var DEFAULTS = {
    montoAmbaRaw: '33000',
    montoRestoRaw: '70000',
    cpMinAmba: '1000',
    cpMaxAmba: '1900',
    showRec: true,
    recTitle: 'Sumá a tu compra',
    recLimit: 10,
    barColor: '#22C55D',
    orangeColor: '#F26522',
    cartWidthRaw: '1650',
    anchorSelector: ''
  };

  var CFG = DEFAULTS;
  var BAR_COLOR = '#22C55D';
  var ORANGE = '#F26522';
  var GOAL_AMBA = 0;
  var GOAL_RESTO = 0;
  var CP_MIN = 1000;
  var CP_MAX = 1900;
  var CART_WIDTH = 1650;

  function safeColor(c, fallback) {
    return /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(String(c).trim()) ? String(c).trim() : fallback;
  }
  function toCents(raw) {
    var n = parseInt(String(raw).replace(/\D/g, ''), 10);
    return (isNaN(n) ? 0 : n) * 100;
  }

  function readConfig() {
    var node = document.getElementById('cudConfig');
    var parsed = null;
    if (node) {
      try { parsed = JSON.parse(node.textContent || '{}'); } catch (e) { parsed = null; }
    }
    CFG = {};
    for (var k in DEFAULTS) {
      if (Object.prototype.hasOwnProperty.call(DEFAULTS, k)) {
        CFG[k] = (parsed && parsed[k] !== undefined && parsed[k] !== null && parsed[k] !== '')
          ? parsed[k]
          : DEFAULTS[k];
      }
    }
    // anchorSelector sí puede quedar vacío a propósito
    if (parsed && typeof parsed.anchorSelector === 'string') CFG.anchorSelector = parsed.anchorSelector;
    if (parsed && typeof parsed.showRec === 'boolean') CFG.showRec = parsed.showRec;

    BAR_COLOR = safeColor(CFG.barColor, '#22C55D');
    ORANGE = safeColor(CFG.orangeColor, '#F26522');
    GOAL_AMBA = toCents(CFG.montoAmbaRaw);
    GOAL_RESTO = toCents(CFG.montoRestoRaw);
    CP_MIN = parseInt(CFG.cpMinAmba, 10); if (isNaN(CP_MIN)) CP_MIN = 1000;
    CP_MAX = parseInt(CFG.cpMaxAmba, 10); if (isNaN(CP_MAX)) CP_MAX = 1900;
    CART_WIDTH = parseInt(String(CFG.cartWidthRaw).replace(/\D/g, ''), 10); if (isNaN(CART_WIDTH)) CART_WIDTH = 1650;
  }

  /* ====== HELPERS ====== */
  var nf = null;
  function money(cents) {
    if (!nf) nf = new Intl.NumberFormat('es-AR');
    return '$' + nf.format(Math.round(cents / 100));
  }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function getCP() { try { return localStorage.getItem('cud_cp') || ''; } catch (e) { return ''; } }
  function setCP(v) { try { localStorage.setItem('cud_cp', v); } catch (e) {} }
  function cpDigits(cp) {
    var d = String(cp).replace(/\D/g, '');
    return d ? parseInt(d.slice(0, 4), 10) : null;
  }
  function goalForCP(cp) {
    var n = cpDigits(cp);
    if (n !== null && n >= CP_MIN && n <= CP_MAX) {
      return { goal: GOAL_AMBA, zone: 'Envío a CABA y AMBA' };
    }
    if (n !== null) {
      return { goal: GOAL_RESTO, zone: 'Envío al interior' };
    }
    return { goal: GOAL_AMBA, zone: '' }; // sin CP: mostramos meta CABA/AMBA como referencia
  }

  /* ====== REFERENCIAS AL DOM (se resuelven en init) ====== */
  var drawer = null, overlay = null, bodyEl = null, foot = null, titleEl = null, subtotalEl = null, cssLink = null;
  var lastAddedProductId = null;

  // matchMedia cacheado: evita recalcular la consulta en cada apertura del drawer
  var mqMobile = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  function isMobile() { return mqMobile ? mqMobile.matches : window.innerWidth <= 749; }

  /* ====== API DE CARRITO ====== */
  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function changeLine(key, qty) {
    if (!bodyEl) return Promise.resolve(null);
    bodyEl.classList.add('cud-loading');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      bodyEl.classList.remove('cud-loading');
      render(cart);
      syncCartPageBar(cart);
      return cart;
    }).catch(function () {
      // Si la red falla dejamos el drawer utilizable en vez de bloqueado
      if (bodyEl) bodyEl.classList.remove('cud-loading');
      return null;
    });
  }
  function addVariant(variantId, btn) {
    if (btn) { btn.disabled = true; btn.textContent = 'Agregando...'; }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (r) { return r.json(); }).then(function (item) {
      if (item && item.product_id) { lastAddedProductId = item.product_id; }
      return getCart();
    }).then(function (cart) {
      render(cart);
      openDrawer();
      return cart;
    }).catch(function () {
      if (btn) { btn.disabled = false; btn.textContent = 'Agregar'; }
    });
  }

  /* ====== RENDER ====== */
  function render(cart) {
    if (!bodyEl || !foot) return;
    if (!cart || cart.item_count === 0) {
      bodyEl.innerHTML = '<div class="cud-empty">Tu carrito está vacío.</div>';
      foot.style.display = 'none';
      if (titleEl) titleEl.textContent = 'Tu carrito';
      return;
    }
    if (titleEl) titleEl.textContent = 'Tu carrito (' + cart.item_count + ')';

    var html = '<ul class="cud-items">';
    cart.items.forEach(function (it) {
      var variant = (it.variant_title && it.variant_title !== 'Default Title')
        ? '<p class="cud-item-variant">' + esc(it.variant_title) + '</p>'
        : '';
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x120$1$2') : '';
      html += ''
        + '<li class="cud-item">'
        +   '<img src="' + esc(img) + '" alt="" loading="lazy" decoding="async" width="72" height="72">'
        +   '<div class="cud-item-info">'
        +     '<p class="cud-item-title">' + esc(it.product_title) + '</p>'
        +     variant
        +     '<div class="cud-item-bottom">'
        +       '<div class="cud-qty">'
        +         '<button type="button" data-key="' + esc(it.key) + '" data-qty="' + (it.quantity - 1) + '">−</button>'
        +         '<span>' + it.quantity + '</span>'
        +         '<button type="button" data-key="' + esc(it.key) + '" data-qty="' + (it.quantity + 1) + '">+</button>'
        +       '</div>'
        +       '<span class="cud-item-price">' + money(it.final_line_price) + '</span>'
        +       '<button class="cud-remove" type="button" data-key="' + esc(it.key) + '" data-qty="0" aria-label="Eliminar">'
        +         '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M8 6V4h8v2m-9 0v14a1 1 0 001 1h8a1 1 0 001-1V6"/></svg>'
        +       '</button>'
        +     '</div>'
        +   '</div>'
        + '</li>';
    });
    html += '</ul>';

    html += shippingBarHTML(cart.total_price);
    if (CFG.showRec) { html += '<div class="cud-rec" id="cudRec" style="display:none"></div>'; }

    bodyEl.innerHTML = html;

    bindCPInput();
    paintBarsSoon();

    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
    foot.style.display = 'block';

    if (CFG.showRec) { loadRecommendations(lastAddedProductId || (cart.items[0] && cart.items[0].product_id)); }
  }

  /* Delegación de eventos: un solo listener en el drawer en lugar de uno por
     botón en cada render. Menos trabajo del hilo principal por interacción. */
  function onBodyClick(e) {
    var t = e.target;
    var btn = t && t.closest ? t.closest('.cud-qty button, .cud-remove, .cud-rec-nav button, .cud-rec-card .add[data-vid]') : null;
    if (!btn) return;

    if (btn.matches('.cud-qty button, .cud-remove')) {
      changeLine(btn.getAttribute('data-key'), parseInt(btn.getAttribute('data-qty'), 10));
      return;
    }
    if (btn.matches('.cud-rec-nav button')) {
      var track = bodyEl.querySelector('.cud-rec-track');
      if (track) track.scrollBy({ left: parseInt(btn.getAttribute('data-dir'), 10) * 170, behavior: 'smooth' });
      return;
    }
    if (btn.matches('.cud-rec-card .add[data-vid]')) {
      addVariant(btn.getAttribute('data-vid'), btn);
    }
  }

  /* ====== BARRA DE ENVÍO GRATIS (HTML reutilizable) ====== */
  function shippingBarHTML(totalCents) {
    var cp = getCP();
    var info = goalForCP(cp);
    var goal = info.goal;
    var pct = goal > 0 ? Math.min(100, Math.round(totalCents / goal * 100)) : 100;
    var falta = Math.max(0, goal - totalCents);
    var msg = falta <= 0
      ? '🎉 ¡Tenés envío gratis!'
      : 'Te falta <b>' + money(falta) + '</b> para el envío gratis';
    var zona = info.zone ? '<span class="cud-cp-zone">' + info.zone + '</span>' : '';
    return ''
      + '<div class="cud-ship">'
      +   '<p class="cud-ship-msg">' + msg + '</p>'
      +   '<div class="cud-bar" data-cud-pct="' + pct + '" style="background:linear-gradient(to right,' + BAR_COLOR + ' ' + pct + '%,#e4e4e0 ' + pct + '%)"></div>'
      +   '<div class="cud-cp">'
      +     '<label>Tu CP:</label>'
      +     '<input type="text" inputmode="numeric" id="cudCP" placeholder="Ej: 1414" value="' + esc(cp) + '" maxlength="8">'
      +     '<button type="button" id="cudCPBtn">Calcular</button>'
      +   '</div>'
      +   zona
      + '</div>';
  }

  /* ====== PINTADO DIRECTO DE LA BARRA (máxima prioridad) ======
     Pinta el relleno verde manipulando el elemento directamente,
     con flag "important": le gana a cualquier CSS del tema o de apps.
     Color hardcodeado: no depende de variables ni de settings.
     Solo escribe estilos, nunca lee geometría, así que no provoca
     recálculos de layout sincrónicos (layout thrashing). */
  function paintBars() {
    var bars = document.querySelectorAll('.cud-bar[data-cud-pct]');
    for (var i = 0; i < bars.length; i++) {
      var el = bars[i];
      var pct = parseInt(el.getAttribute('data-cud-pct'), 10);
      if (isNaN(pct)) pct = 0;
      if (pct < 0) pct = 0;
      if (pct > 100) pct = 100;
      var grad = 'linear-gradient(to right, #22C55D 0%, #22C55D ' + pct + '%, #e4e4e0 ' + pct + '%, #e4e4e0 100%)';
      el.style.setProperty('background', grad, 'important');
      el.style.setProperty('background-image', grad, 'important');
      el.style.setProperty('height', '9px', 'important');
      el.style.setProperty('border-radius', '20px', 'important');
      el.style.setProperty('display', 'block', 'important');
      el.style.setProperty('width', '100%', 'important');
      el.style.setProperty('opacity', '1', 'important');
      el.style.setProperty('visibility', 'visible', 'important');
    }
  }
  /* Las escrituras se agrupan en un frame de animación: nunca corren
     dentro del handler de click, que es lo que empeora el INP. */
  var paintQueued = false;
  function schedulePaint() {
    if (paintQueued) return;
    paintQueued = true;
    (window.requestAnimationFrame || function (f) { return setTimeout(f, 16); })(function () {
      paintQueued = false;
      paintBars();
    });
  }
  /* Repinta ahora y dos veces más por si una app reescribe el DOM después */
  function paintBarsSoon() {
    schedulePaint();
    setTimeout(schedulePaint, 300);
    setTimeout(schedulePaint, 1200);
  }

  function bindCPInput() {
    var btn = document.getElementById('cudCPBtn');
    var inp = document.getElementById('cudCP');
    if (!btn || !inp) return;
    function apply() {
      setCP(inp.value.trim());
      getCart().then(function (c) { render(c); syncCartPageBar(c); });
    }
    btn.addEventListener('click', apply);
    inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); apply(); } });
  }

  /* ====== RECOMENDADOS ====== */
  function loadRecommendations(productId) {
    var box = document.getElementById('cudRec');
    if (!box || !productId) return;
    fetch('/recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=' + encodeURIComponent(CFG.recLimit) + '&intent=related',
      { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var prods = (data && data.products) ? data.products : [];
        if (!prods.length) { box.style.display = 'none'; return; }
        var cards = '';
        prods.forEach(function (p) {
          var img = (p.featured_image || p.image || '');
          if (img) { img = img.replace(/(\.[a-z]+)(\?|$)/i, '_200x200$1$2'); }
          var avail = p.variants && p.variants.filter(function (v) { return v.available; });
          var btn;
          if (p.variants && p.variants.length === 1 && p.variants[0].available) {
            btn = '<button class="add" type="button" data-vid="' + esc(p.variants[0].id) + '">Agregar</button>';
          } else if (avail && avail.length) {
            btn = '<a class="add" href="' + esc(p.url) + '">Elegir opción</a>';
          } else {
            btn = '<button class="add" type="button" disabled>Sin stock</button>';
          }
          cards += ''
            + '<div class="cud-rec-card">'
            +   '<a href="' + esc(p.url) + '"><img src="' + esc(img) + '" alt="" loading="lazy" decoding="async" width="200" height="200"></a>'
            +   '<p class="t">' + esc(p.title) + '</p>'
            +   '<p class="p">' + money(p.price) + '</p>'
            +   btn
            + '</div>';
        });
        box.innerHTML = ''
          + '<div class="cud-rec-head"><h3>' + esc(CFG.recTitle) + '</h3>'
          +   '<div class="cud-rec-nav">'
          +     '<button type="button" data-dir="-1"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 18l-6-6 6-6"/></svg></button>'
          +     '<button type="button" data-dir="1"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg></button>'
          +   '</div>'
          + '</div>'
          + '<div class="cud-rec-track">' + cards + '</div>';
        box.style.display = 'block';
        // Los clics del carrusel y de "Agregar" los maneja la delegación en onBodyClick
      })
      .catch(function () { box.style.display = 'none'; });
  }

  /* ====== ABRIR / CERRAR ====== */
  function ensureCss() {
    // La hoja se carga sin bloquear el render (media="print"); al abrir el
    // drawer nos aseguramos de que ya esté aplicada.
    if (!cssLink) cssLink = document.getElementById('cudCss');
    if (cssLink && cssLink.media !== 'all') cssLink.media = 'all';
  }
  function openDrawer() {
    if (!drawer || !overlay) return;
    ensureCss();
    drawer.classList.remove('cud-idle');
    drawer.classList.add('cud-open');
    overlay.classList.add('cud-open');
    drawer.setAttribute('aria-hidden', 'false');
    // En mobile bloqueamos el scroll del fondo; en desktop dejamos seguir navegando la tienda
    if (isMobile()) { document.body.style.overflow = 'hidden'; }
  }
  function closeDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.remove('cud-open');
    overlay.classList.remove('cud-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  /* Recién cuando terminó la animación de cierre marcamos el drawer como
     inactivo. Así el navegador puede saltear el layout de su contenido sin
     que se vea ningún cambio durante el cierre. */
  function onDrawerTransitionEnd(e) {
    if (e.target !== drawer || e.propertyName !== 'transform') return;
    if (!drawer.classList.contains('cud-open')) drawer.classList.add('cud-idle');
  }

  /* ====== INTERCEPTAR "AGREGAR AL CARRITO" ====== */
  function onSubmitCapture(e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var fd = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (item) {
        if (item && item.status) { // error (ej: sin stock)
          alert(item.description || item.message || 'No se pudo agregar el producto.');
          return null;
        }
        if (item && item.product_id) { lastAddedProductId = item.product_id; }
        return getCart();
      })
      .then(function (cart) { if (cart) { render(cart); openDrawer(); } });
  }

  /* ====== BARRA EN LA PÁGINA /cart ====== */
  function syncCartPageBar(cart) {
    var holder = document.getElementById('cudCartPageBar');
    if (!holder || !cart) return;
    holder.innerHTML = shippingBarHTML(cart.total_price);
    bindCPInput();
    paintBarsSoon();
  }
  function findAnchor() {
    // 1) Selector configurado a mano en el Customizer (máxima precisión)
    if (CFG.anchorSelector) {
      var custom = null;
      try { custom = document.querySelector(CFG.anchorSelector); } catch (err) { custom = null; }
      if (custom) return custom;
    }
    // 2) Detectar automáticamente el recuadro "Opciones adicionales" por su texto
    var els = document.querySelectorAll('h1,h2,h3,h4,h5,h6,p,span,strong,b');
    for (var i = 0; i < els.length; i++) {
      var t = (els[i].textContent || '').trim();
      if (t.length <= 40 && t.toLowerCase().indexOf('opciones adicionales') !== -1) {
        var node = els[i];
        for (var up = 0; up < 4 && node.parentElement; up++) {
          var p = node.parentElement;
          if (p.matches('section,[class*="card"],[class*="box"],[class*="block"],[class*="gift"],[class*="regalo"],[class*="adicional"],[class*="option"],[class*="upsell"],[class*="addon"]')) {
            return p;
          }
          node = p;
        }
        return els[i].parentElement || els[i];
      }
    }
    // 3) Respaldo: arriba del bloque de subtotal/checkout de Dawn
    return document.querySelector('#main-cart-footer') ||
           document.querySelector('.cart__footer') ||
           document.querySelector('cart-items') ||
           document.querySelector('.cart__items');
  }
  function initCartPage() {
    if (!/\/cart\/?$/.test(window.location.pathname)) return;
    if (document.getElementById('cudCartPageBar')) return; // evitar duplicados
    ensureCss();
    var anchor = findAnchor();
    if (!anchor || !anchor.parentNode) return;
    var holder = document.createElement('div');
    holder.id = 'cudCartPageBar';
    holder.className = 'cud-cartpage-ship';
    holder.style.maxWidth = CART_WIDTH + 'px';
    holder.style.setProperty('--cud-green', BAR_COLOR);
    anchor.parentNode.insertBefore(holder, anchor);
    getCart().then(syncCartPageBar);

    // Reaccionar a cambios de cantidad en la página de carrito
    var watch = document.querySelector('cart-items') || document.querySelector('.cart__items');
    if (watch && window.MutationObserver) {
      var t;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () { getCart().then(syncCartPageBar); }, 350);
      }).observe(watch, { childList: true, subtree: true });
    }
  }

  /* ====== INICIALIZACIÓN ====== */
  function bindSection() {
    var nextDrawer = document.getElementById('cudDrawer');
    if (!nextDrawer) return false;

    drawer = nextDrawer;
    overlay = document.getElementById('cudOverlay');
    bodyEl = document.getElementById('cudBody');
    foot = document.getElementById('cudFoot');
    titleEl = document.getElementById('cudTitle');
    subtotalEl = document.getElementById('cudSubtotal');
    cssLink = document.getElementById('cudCss');

    // Los listeners viven en los nodos de la sección: si el editor de temas
    // reemplaza el markup, se vuelven a colgar sobre los nodos nuevos.
    var closeBtn = document.getElementById('cudClose');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    if (bodyEl) bodyEl.addEventListener('click', onBodyClick);
    drawer.addEventListener('transitionend', onDrawerTransitionEnd);
    return true;
  }

  function init() {
    readConfig();
    bindSection();
    initCartPage();
  }

  // Listeners a nivel documento: se registran una sola vez.
  document.addEventListener('submit', onSubmitCapture, true); // fase de captura: corre antes que Dawn
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ====== EDITOR DE TEMAS ====== */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && !e.target.querySelector('#cudDrawer')) return;
    init();
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target && e.target.querySelector && !e.target.querySelector('#cudDrawer')) return;
    getCart().then(function (cart) { render(cart); openDrawer(); });
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target && e.target.querySelector && !e.target.querySelector('#cudDrawer')) return;
    closeDrawer();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
